import React from "react";
import styled from "styled-components";
import toNumber from "lodash/toNumber";
import isEmpty from "lodash/isEmpty";
import UISlider from "components/Slider";

const Text = styled.div`
  margin-bottom: 3rem;
  font-size: 3rem;
  font-weight: bold;
  color: #000;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 4rem;
  }
`;

const Slider = (props) => {
  const min = toNumber(props.min.value);
  const max = toNumber(props.max.value);
  const step = toNumber(props.increment);

  const handleChange = (value) => {
    const { id, type } = props;

    props.dispatch({
      type: "CHANGE_ANSWER",
      answer: { id, type, value },
      multiChoice: props.multiChoice,
    });
  };

  const value = getValue(props, min);

  let label = props.title;
  if (value === max && !isEmpty(props.max.label)) label = props.max.label;
  if (value === min && !isEmpty(props.min.label)) label = props.min.label;

  const disabled =
    !props.multiChoice && !!props.answer.find((a) => a.type === "text");

  return (
    <React.Fragment>
      <Text>{`${value}${label}`}</Text>
      <UISlider
        onChange={handleChange}
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
      />
    </React.Fragment>
  );
};

export default Slider;

function getValue(props, defaultValue) {
  const answer = props.answer.find((a) => a.id === props.id);
  return answer ? answer.value : defaultValue;
}
